import { Helmet } from "react-helmet-async";

const SITE = "https://theboba.place";
const LOGO = "https://theboba.place/logo.png";

export default function SEO({ title, description, path = "/", image = LOGO, type = "website", jsonLd }) {
  const fullTitle = title ? `${title} — The Boba Place` : "The Boba Place — Fresh Boba & Tea in Hailey, Ketchum & Sun Valley, ID";
  const desc = description || "Small-batch boba and tea drinks with hand-cooked tapioca pearls. Hailey, Ketchum and Sun Valley, Idaho.";
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export { SITE, LOGO };
